"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _errorCodes = _interopRequireDefault(require("./error-codes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Concatenates to message values together if both are provided.
 *
 * @param {string} overallMessage Will be prepended to specificMessage, delimited with a colon, if supplied.
 * @param {string} specificMessage Will be concatenated with overallMessage, if supplied. Otherwise the return value of
 *  the method will be specificMessage as-is.
 * @returns {string} A message value.
 */
function getFullMessage(overallMessage, specificMessage) {
  if (overallMessage) {
    return "".concat(overallMessage, ": ").concat(specificMessage);
  }

  return specificMessage;
}
/**
 * Custom Error class containing additional information specific to the upload process. This primarily consists of an
 * error code, which can be used by consumers to provide more specific information about the nature of an error.
 */


var UploadError = /*#__PURE__*/function (_Error) {
  _inherits(UploadError, _Error);

  var _super = _createSuper(UploadError);

  _createClass(UploadError, null, [{
    key: "fromError",

    /**
     * Constructs a new UploadError instance out of a given error message. The method will attempt to create the
     * most specific type of error it can based on what it receives.
     *
     * @param {*} error Object from which to create the UploadError instance. Can be several things, including an
     *  UploadError instance, an error as thrown by axios, a string, or another Error instance.
     * @param {string} errorMessage Will appear in the error's "message" value.
     * @returns {UploadError} An upload error instance.
     */
    value: function fromError(error) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var message = error.message,
          code = error.code,
          uploadError = error.uploadError,
          response = error.response,
          stack = error.stack;

      if (uploadError) {
        return error;
      }

      if (response) {
        var status = response.status;
        var _code = _errorCodes.default.UNKNOWN;

        if (status === 409) {
          _code = _errorCodes.default.ALREADY_EXISTS;
        } else if (status === 403) {
          _code = _errorCodes.default.FORBIDDEN;
        } else if (status === 400) {
          _code = _errorCodes.default.INVALID_OPTIONS;
        } else if (status === 401) {
          _code = _errorCodes.default.NOT_AUTHORIZED;
        } else if (status === 404) {
          _code = _errorCodes.default.NOT_FOUND;
        } else if (status === 501) {
          _code = _errorCodes.default.NOT_SUPPORTED;
        }

        return new UploadError("Request failed with status code ".concat(status), _code, stack);
      }

      if (message && code) {
        return new UploadError(getFullMessage(errorMessage, message), code, stack);
      }

      if (message) {
        return new UploadError(getFullMessage(errorMessage, message), _errorCodes.default.UNKNOWN, stack);
      }

      if (typeof error === 'string') {
        return new UploadError(getFullMessage(errorMessage, error), _errorCodes.default.UNKNOWN);
      }

      try {
        return new UploadError(getFullMessage(errorMessage, JSON.stringify(error)), _errorCodes.default.UNKNOWN, stack);
      } catch (e) {
        return new UploadError(getFullMessage(errorMessage, error), _errorCodes.default.UNKNOWN, stack);
      }
    }
    /**
     * Constructs a new instance containing the provided information.
     *
     * @param {string} message The message that will appear with the Error instance.
     * @param {string} code The code indicating the specific type of error.
     * @param {string} [innerStack] Additional stack information if the UploadError instance originated
     *  from another Error.
     */

  }]);

  function UploadError(message, code) {
    var _this;

    var innerStack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    _classCallCheck(this, UploadError);

    _this = _super.call(this, message);
    _this.code = code;
    _this.innerStack = innerStack;
    _this.uploadError = true;
    return _this;
  }
  /**
   * Retrieves the error code representing the specific type of error. See ErrorCodes for more
   * information.
   *
   * @returns {string} An error code value.
   */


  _createClass(UploadError, [{
    key: "getCode",
    value: function getCode() {
      return this.code;
    }
    /**
     * Retrieves the upload error's status as an HTTP status code.
     *
     * @returns {number} An HTTP status code.
     */

  }, {
    key: "getHttpStatusCode",
    value: function getHttpStatusCode() {
      var code = this.getCode();

      if (code === _errorCodes.default.ALREADY_EXISTS) {
        return 409;
      } else if (code === _errorCodes.default.FORBIDDEN) {
        return 403;
      } else if (code === _errorCodes.default.INVALID_OPTIONS) {
        return 400;
      } else if (code === _errorCodes.default.NOT_AUTHORIZED) {
        return 401;
      } else if (code === _errorCodes.default.NOT_FOUND) {
        return 404;
      } else if (code === _errorCodes.default.TOO_LARGE) {
        return 413;
      } else if (code === _errorCodes.default.NOT_SUPPORTED) {
        return 501;
      } else {
        return 500;
      }
    }
    /**
     * Retrieves a message describing the error.
     *
     * @returns {string} The error's message.
     */

  }, {
    key: "getMessage",
    value: function getMessage() {
      return this.message;
    }
    /**
     * Retrieves the inner stack of the error, as provided to the constructor.
     *
     * @returns {string} The error's inner stack.
     */

  }, {
    key: "getInnerStack",
    value: function getInnerStack() {
      return this.innerStack;
    }
    /**
     * Converts the error instance into a simplified object form.
     *
     * @returns {object} Simple object representation of the error.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {
        message: this.message,
        code: this.code
      };

      if (this.innerStack) {
        json.innerStack = this.innerStack;
      }

      return json;
    }
    /**
     * Converts the error to a string, which will be a stringified version of the error's toJSON() method.
     *
     * @returns {string} String representation of the error.
     */

  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this);
    }
  }]);

  return UploadError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.default = UploadError;